var React = require('react');

function ExclamationCircleOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m 10.798285,15.605146 h 2.40343 v 2.40343 h -2.40343 z m 0,-9.6137223 h 2.40343 v 7.2102913 h -2.40343 z M 12,-0.01715266 C 5.3545146,-0.01715266 -0.01715266,5.390566 -0.01715266,12 A 12.017153,12.017153 0 1 0 12,-0.01715266 Z M 12,21.613722 A 9.6137221,9.6137221 0 1 1 12,2.3862779 9.6137221,9.6137221 0 0 1 12,21.613722 Z","style":{"strokeWidth":"1.20172"}}));
}

ExclamationCircleOutline.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = ExclamationCircleOutline;

ExclamationCircleOutline.default = ExclamationCircleOutline;
